import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDataWithToken } from '../../../Utils/restUtils';
import { getIndustry } from '../../../CommonURL';

function IndustryFilter({ setIsIndustry, selectedIndustry,IsIndustry }) {
    const [industryOptions, setIndustryOptions] = useState([]);

    useEffect(() => {
        industryData();

    }, []);
   useEffect(() => {
    if (selectedIndustry && industryOptions.length > 0) {
        const industry = industryOptions.find((item) => item.value == selectedIndustry);
        setIsIndustry(industry || null);
    }
   
}, [selectedIndustry, industryOptions])


    const industryData = async () => {
        const data = await getDataWithToken(getIndustry);
        if (data?.status) {
            setIndustryOptions(
                data.data.map(({ id, name }) => ({ value: id, label: name }))
            );
        } else {
            handleApiError(data.status);
        }
    };

    const handleChange = (selectedOption) => setIsIndustry(selectedOption);
    return (
        <Select
            options={industryOptions}
            onChange={handleChange}
            placeholder="Industry"
            isClearable
            value={IsIndustry}
            className="col-sm-12"
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: 45,
                }),
            }}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary25: 'rgba(83, 70, 134, 0.474)',
                    primary: '#534686',
                    primary50: 'rgba(83, 70, 134, 0.3)'
                },
            })}
        />
    )
}

export default IndustryFilter